/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AddClientContact } from './AddClientContact';
import {
    AddClientContactFromJSON,
    AddClientContactFromJSONTyped,
    AddClientContactToJSON,
} from './AddClientContact';

/**
 * A payload that will add multiple client contacts to a client organization.
 * @export
 * @interface BulkAddClientContact
 */
export interface BulkAddClientContact {
    /**
     * 
     * @type {Array<AddClientContact>}
     * @memberof BulkAddClientContact
     */
    clientContacts?: Array<AddClientContact>;
}

/**
 * Check if a given object implements the BulkAddClientContact interface.
 */
export function instanceOfBulkAddClientContact(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BulkAddClientContactFromJSON(json: any): BulkAddClientContact {
    return BulkAddClientContactFromJSONTyped(json, false);
}

export function BulkAddClientContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkAddClientContact {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientContacts': !exists(json, 'clientContacts') ? undefined : ((json['clientContacts'] as Array<any>).map(AddClientContactFromJSON)),
    };
}

export function BulkAddClientContactToJSON(value?: BulkAddClientContact | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clientContacts': value.clientContacts === undefined ? undefined : ((value.clientContacts as Array<any>).map(AddClientContactToJSON)),
    };
}

